import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { PaginatorComponent } from './paginator/paginator.component';
import { ResourcefulIndexComponent } from './resourceful-index/resourceful-index.component';
import { MatTableExporterModule } from 'mat-table-exporter';



@NgModule({
  declarations: [PaginatorComponent, ResourcefulIndexComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    ReactiveFormsModule,
    RouterModule,
    MatTableExporterModule
  ],
  exports: [PaginatorComponent, ResourcefulIndexComponent]
})
export class ResourcefulIndexModule { }
